import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function clearPromoCode(input: { enrollmentId: number; propositionId: number }) {
  const { enrollmentId, propositionId } = input
  return restApiClient
    .url(constructApiUrl(API.enrollments.clearPromoCode.url, { id: enrollmentId, propositionId }))
    .patch()
}
